import './App.css';
import './DarkMode.css';
import './index.css'
import dayjs from "dayjs";
import "dayjs/locale/tr";
import trTR from 'antd/locale/tr_TR';
import '@fortawesome/fontawesome-free/css/all.min.css';
import React, { useState, useEffect } from 'react';
import { Layout, ConfigProvider, theme, App as AntdApp } from 'antd';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SideMenu from './components/header/SideMenu.jsx';
import HeaderComponent from './components/header/HeaderComponent';
import DashboardContent from './components/giris/DashboardContent';
import ListPage from './components/List';
import PivotPage from './components/pivot/Pivot';
import FaturaPage from './components/fatura/FaturaPage';
import BankaFaturaTalepIslemPage from './components/fatura/BankaFaturaTalepIslemPage.jsx';
import BankaFaturaIslemPage from './components/fatura/BankaFaturaIslemPage';
import ElektrikFaturaIslemPage from './components/fatura/ElektrikFaturaIslemPage';
import DepoPage from './components/insaat/DepoPage';
import KurulumHareketleriPage from './components/insaat/KurulumHareketleriPage';
import TamimlerPage from './components/diger/TamimlerPage';
import DemirbasPage from './components/diger/DemirbasPage';
import AraclarPage from './components/diger/AraclarPage';
import SatilanAraclarPage from './components/diger/SatilanAraclarPage.jsx';
import AracDetayPage from './components/diger/AracDetayPage.jsx'; 
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import PermissionBasedRoute from './components/route/PermissionBasedRoute';
import updateLocale from "dayjs/plugin/updateLocale";
import customParseFormat from "dayjs/plugin/customParseFormat";
import MapPage from './components/harita/pages/MapPage';
import CardDetailPage from './components/harita/pages/CardDetailPage';
import LocationDetailPage from './components/harita/pages/LocationDetailPage';
import PlatformDetailPage from './components/harita/pages/PlatformDetailPage';
import ImageArchivePage from './components/harita/pages/ImageArchivePage';
import LokasyonSozlesme from './components/harita/pages/LokasyonSozlesme';
import SignInPage from './components/giris/SignInPage.jsx';
import ExcelAnalistPage from './components/analiz/ExcelAnalistPage.jsx';
import Pdf2ExcelPage from './components/analiz/Pdf2ExcelPage.jsx';
import CreatePdf from './components/analiz/CreatePdf.jsx';
import SifreSifirlamaPage from './components/giris/SifreSifirlama.jsx';
//import RehberPage from './components/ik/RehberPage';
import FormManager from './components/form/FormManager.jsx';
import SirketlerPage from './components/diger/SirketlerPage';
import ToplantiPage from './components/diger/ToplantiPage';
import ToplantiOzetPage from './components/diger/ToplantiOzetPage';
import ToplantiListPage from './components/diger/ToplantiListPage';
import KayitEklePage from './components/ik/KayitEklePage';
import OrganizasyonSemasiPage from './components/organizasyon/OrganizasyonSemasiPage.jsx';
import BankaSozlesmeFormDetay from './components/harita/pages/BankaSozlesmeFormDetay.jsx';
import YerSozlesmeFormDetay from './components/harita/pages/YerSozlesmeFormDetay.jsx';
import SunumDuzenle from './components/harita/pages/SunumDuzenle.jsx';
import MaliRaporPage from './components/harita/pages/MaliRaporPage.jsx'; 
import OngoruPage from './components/harita/pages/OngoruPage.jsx';
import YetkiYonetimPage from './components/yetki/YetkiYonetimPage.jsx';
import MarkaPortaliPage from './components/marka/MarkaPortaliPage.jsx';
import YonetimRaporPage from './components/yonetim/YonetimRaporPage.jsx';
import HarcirahPersonel from './components/harcirah/HarcirahPersonel.jsx';
import HarcirahRezervasyon from './components/harcirah/HarcirahRezervasyon.jsx';
import HarcirahYonetim from './components/harcirah/HarcirahYonetim.jsx';
import { HarcirahFinans, HarcirahOnaylarim, HarcirahRaporEkrani } from './components/harcirah/ekranlar.jsx';
import SatisSureciPage from './components/satis/SatisSureciPage.jsx';
import DomainHostingPage from './components/bt/DomainHostingPage.jsx';
import GirisGuvenligiPage from './components/bt/GirisGuvenligiPage.jsx';
import OturumSayaci from './components/oturum/OturumSayaci.jsx';
import BiDemoPage from './components/bi/BiDemoPage.jsx';
import Gorev from './components/header/Gorev.jsx';
import ProfilPage from './components/profil/Profil.jsx';
import Dilekce from './components/profil/Dilekce.jsx';
import IKPage from './components/ik/ik.jsx';
import ZimmetTutanak from './components/ik/Zimmetler.jsx';
import PersonelPage from './components/ik/Personel.jsx';
import Borsa from './components/borsa/Borsa.jsx';
import BorsaGunluk from './components/borsa/BorsaGunluk.jsx';
import ProjelerPage from './components/harita/pages/ProjelerPage.jsx';
import SurecTakipPage from './components/insaat/SurecTakipPage.jsx';
import EnerjiSurecPage from './components/insaat/EnerjiSurecPage.jsx';
import InsaatEnerjiPage from './components/insaat/InsaatEnerjiPage.jsx';
import FinansPage from './components/finans/FinansPage';
import ProjeMasrafPage from './components/finans/ProjeMasrafPage';
import SurecIzlemePage from './components/finans/SurecIzlemePage';
import SozlesmeFaturaPage from './components/sozlesme/SozlesmeFaturaPage';

const { Header, Sider, Content } = Layout;
const AppContent = () => {
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem('sideMenuCollapsed');
    return saved !== null ? JSON.parse(saved) : false;
  });
  // Dar ekranda menü tamamen gizlenir (collapsedWidth=0), masaüstünde ikon
  // şeridi olarak kalır (antd varsayılanı 80px) — mevcut davranış korunur.
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );
  const { darkMode } = useTheme();
  const { defaultAlgorithm, darkAlgorithm } = theme;

  dayjs.extend(updateLocale);
  dayjs.extend(customParseFormat);

  useEffect(() => {
    document.body.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  const toggleSider = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem('sideMenuCollapsed', JSON.stringify(next));
  };

  const publicRoutes = [
    { path: "/giris", element: <SignInPage /> },
    { path: "/sifre-sifirlama", element: <SifreSifirlamaPage /> }
  ];

  const protectedRoutes = [
    { path: "/home", element: <PermissionBasedRoute><DashboardContent /></PermissionBasedRoute> },
    { path: "/list", element: <PermissionBasedRoute><ListPage /></PermissionBasedRoute> },
    { path: "/pivot", element: <PermissionBasedRoute><PivotPage /></PermissionBasedRoute> },
    { path: "/map", element: <PermissionBasedRoute><MapPage /></PermissionBasedRoute> },
    { path: "/depo", element: <PermissionBasedRoute><DepoPage /></PermissionBasedRoute> },
    { path: "/kurulum_hareketleri", element: <PermissionBasedRoute><KurulumHareketleriPage /></PermissionBasedRoute> },
    { path: "/projeler", element: <PermissionBasedRoute><ProjelerPage /></PermissionBasedRoute> },
    { path: "/surec_takip", element: <PermissionBasedRoute><SurecTakipPage /></PermissionBasedRoute> },
    { path: "/enerji_surec", element: <PermissionBasedRoute><EnerjiSurecPage /></PermissionBasedRoute> },
    // İnşaat planlama (tablı ekran) — prod ile aynı yol.
    { path: "/insaat-enerji", element: <PermissionBasedRoute><InsaatEnerjiPage /></PermissionBasedRoute> },
    { path: "/finans", element: <PermissionBasedRoute><FinansPage /></PermissionBasedRoute> },
    { path: "/proje-masraflari", element: <PermissionBasedRoute><ProjeMasrafPage /></PermissionBasedRoute> },
    { path: "/sozlesme-fatura", element: <PermissionBasedRoute><SozlesmeFaturaPage /></PermissionBasedRoute> },
    // /surec-izleme prod'da FİNANS süreç izleme ekranı; inşaat listesi /surec_takip'te.
    { path: "/surec-izleme", element: <PermissionBasedRoute><SurecIzlemePage /></PermissionBasedRoute> },
    { path: "/tamimler", element: <PermissionBasedRoute><TamimlerPage /></PermissionBasedRoute> },
    { path: "/detay/:maptriksId", element: <PermissionBasedRoute><CardDetailPage /></PermissionBasedRoute> },
    { path: "/map/:maptriksId", element: <PermissionBasedRoute><MapPage /></PermissionBasedRoute> },
    { path: "/edit/location_detail/:maptriksId", element: <PermissionBasedRoute><LocationDetailPage /></PermissionBasedRoute> },
    { path: "/platform_detay/:id", element: <PermissionBasedRoute><PlatformDetailPage /></PermissionBasedRoute> },
    { path: "/arsiv/:maptriksId", element: <PermissionBasedRoute><ImageArchivePage /></PermissionBasedRoute> },
    { path: "/lokasyon_sozlesme/:maptriksId", element: <PermissionBasedRoute><LokasyonSozlesme /></PermissionBasedRoute> },
    { path: "/excel-analist", element: <PermissionBasedRoute><ExcelAnalistPage /></PermissionBasedRoute> },
    { path: "/pdf2excel", element: <PermissionBasedRoute><Pdf2ExcelPage /></PermissionBasedRoute> },
    { path: "/latex", element: <PermissionBasedRoute><CreatePdf /></PermissionBasedRoute> },
    { path: "/banka_sozlesme_detay/:id", element: <PermissionBasedRoute><BankaSozlesmeFormDetay /></PermissionBasedRoute> },
    { path: "/yer_sozlesme_detay/:id", element: <PermissionBasedRoute><YerSozlesmeFormDetay /></PermissionBasedRoute> },
    { path: "/faturalar", element: <PermissionBasedRoute><FaturaPage /></PermissionBasedRoute> },
    { path: "/banka_fatura_talep_islem/:id", element: <PermissionBasedRoute><BankaFaturaTalepIslemPage /></PermissionBasedRoute> },
    { path: "/elektrik_fatura_islem/:id", element: <PermissionBasedRoute><ElektrikFaturaIslemPage /></PermissionBasedRoute> },
    { path: "/banka_fatura_islem/:id", element: <PermissionBasedRoute><BankaFaturaIslemPage /></PermissionBasedRoute> },
    { path: "/demirbas_yonetimi", element: <PermissionBasedRoute><DemirbasPage /></PermissionBasedRoute> },
    { path: "/araclar", element: <PermissionBasedRoute><AraclarPage /></PermissionBasedRoute> },
    { path: "/satilan_araclar", element: <PermissionBasedRoute><SatilanAraclarPage /></PermissionBasedRoute> },
    { path: "/arac-detay/:page/:id", element: <PermissionBasedRoute><AracDetayPage /></PermissionBasedRoute> },
    { path: "/form_manager/:id", element: <PermissionBasedRoute><FormManager /></PermissionBasedRoute> },
    { path: "/sirketler", element: <PermissionBasedRoute><SirketlerPage /></PermissionBasedRoute> },
    { path: "/toplanti", element: <PermissionBasedRoute><ToplantiPage /></PermissionBasedRoute> },
    { path: "/toplanti_ozet/:id", element: <PermissionBasedRoute><ToplantiOzetPage /></PermissionBasedRoute> },
    { path: "/toplanti_liste", element: <PermissionBasedRoute><ToplantiListPage /></PermissionBasedRoute> },
    { path: "/kayit-ekle", element: <PermissionBasedRoute><KayitEklePage /></PermissionBasedRoute> },
    { path: "/organizasyon-semasi", element: <PermissionBasedRoute tip="organizasyon_semasi" anahtar="wr" permissionType="w"><OrganizasyonSemasiPage /></PermissionBasedRoute> },
    { path: "/organizasyon-semasi/:semaId", element: <PermissionBasedRoute tip="organizasyon_semasi" anahtar="wr" permissionType="w"><OrganizasyonSemasiPage /></PermissionBasedRoute> },
    { path: "/sunum", element: <PermissionBasedRoute><SunumDuzenle /></PermissionBasedRoute> },
    { path: "/mali_rapor", element: <PermissionBasedRoute><MaliRaporPage /></PermissionBasedRoute> },
    { path: "/mali_rapor/:maptriksId", element: <PermissionBasedRoute><MaliRaporPage /></PermissionBasedRoute> },
    { path: "/ongoru/:maptriksId", element: <PermissionBasedRoute><OngoruPage /></PermissionBasedRoute> },
    { path: "/gorev", element: <PermissionBasedRoute><Gorev /></PermissionBasedRoute> },
    { path: "/profil", element: <PermissionBasedRoute><ProfilPage /></PermissionBasedRoute> },
    { path: "/ik/dilekce/:id", element: <PermissionBasedRoute><Dilekce /></PermissionBasedRoute> },
    { path: "/ik", element: <PermissionBasedRoute><IKPage /></PermissionBasedRoute> },
    { path: "/ik/zimmet-tutanak/:kullaniciNo", element: <PermissionBasedRoute><ZimmetTutanak /></PermissionBasedRoute> },
    { path: "/ik/personel/:kullaniciNo", element: <PermissionBasedRoute><PersonelPage /></PermissionBasedRoute> },
    { path: "/borsa", element: <PermissionBasedRoute><Borsa /></PermissionBasedRoute> },
    { path: "/borsa_gunluk", element: <PermissionBasedRoute><BorsaGunluk /></PermissionBasedRoute> },
    { path: "/yetki-yonetim", element: <PermissionBasedRoute tip="Ayar" anahtar="Yetkiler" permissionType="w"><YetkiYonetimPage /></PermissionBasedRoute> },
    // Marka Portalı (07.10.2026) — menüde yok, adresle açılır; yetki Yetki Yönetimi'nden verilir.
    { path: "/marka-portal", element: <PermissionBasedRoute tip="Genel" anahtar="Marka Portalı"><MarkaPortaliPage /></PermissionBasedRoute> },
    // Yönetim Satış Raporu (08.10.2026) — menüde yok; yalnız YK Başkanı / Genel Müdür / CFO.
    { path: "/yonetim-rapor", element: <PermissionBasedRoute tip="Genel" anahtar="Yönetim Raporu"><YonetimRaporPage /></PermissionBasedRoute> },
    // 23.10.2026: Harcırah test aşamasında — menüde yok; backend ayrıca kişiye kilitli (KISI_KILIDI).
    // 24.10.2026 ekran ayrımı: personel (her çalışan) · rezervasyon (Harcırah w) · onay ve rapor (onaycılar; rapor Harcırah r)
    { path: "/harcirah", element: <PermissionBasedRoute><HarcirahPersonel /></PermissionBasedRoute> },
    { path: "/harcirah/rezervasyon", element: <PermissionBasedRoute><HarcirahRezervasyon /></PermissionBasedRoute> },
    { path: "/harcirah/yonetim", element: <PermissionBasedRoute><HarcirahYonetim /></PermissionBasedRoute> },
    { path: "/harcirah/finans", element: <PermissionBasedRoute><HarcirahFinans /></PermissionBasedRoute> },
    { path: "/harcirah/onay", element: <PermissionBasedRoute><HarcirahOnaylarim /></PermissionBasedRoute> },
    { path: "/harcirah/rapor", element: <PermissionBasedRoute><HarcirahRaporEkrani /></PermissionBasedRoute> },
    // 26.10.2026: Satış Süreci — erişim backend'de (`Genel / Satış Süreci` r/w VEYA satis_kesif_ekip üyeliği;
    // pozisyonsuz saha personeli var), bu yüzden tip/anahtar verilmez; 403'te sayfa kendi 'Erişim yok' ekranını gösterir.
    { path: "/satis-sureci", element: <PermissionBasedRoute><SatisSureciPage /></PermissionBasedRoute> },
    // 27.10.2026: BI v2 rakam teyit ekranı — /bi-v2 uçları Genel / Finans (okuma) ister; 403'te sayfa 'Erişim yok' gösterir.
    { path: "/bi-demo", element: <PermissionBasedRoute><BiDemoPage /></PermissionBasedRoute> },
    // 30.10.2026: BT domain ve hosting takibi — erişim backend'de (BT pozisyonları, routes/bt_yenileme.py); 403'te 'Erişim yok'.
    { path: "/bt/domain-hosting", element: <PermissionBasedRoute><DomainHostingPage /></PermissionBasedRoute> },
    // 03.11.2026: yalnız 327 ve 199 (routes/giris_guvenligi.py KISI_KILIDI; diğerlerine 403 → erişim yok ekranı)
    { path: "/bt/giris-guvenligi", element: <PermissionBasedRoute><GirisGuvenligiPage /></PermissionBasedRoute> }
  ];

  return (
    <ConfigProvider
      locale={trTR}
      datePicker={{ timeZone: "Europe/Istanbul" }}
      theme={{ algorithm: darkMode ? darkAlgorithm : defaultAlgorithm }}
    >
      <AntdApp>
        <Router>
          <Routes>
            {publicRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}
            {protectedRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <Layout
                    style={{ minHeight: '100vh', background: darkMode ? 'var(--dark-bg)' : 'var(--color-bg-secondary)' }}
                    className={darkMode ? 'dark-theme' : 'light-theme'}
                  >
                    <Sider
                      trigger={null}
                      collapsible
                      collapsed={collapsed}
                      width={220}
                      breakpoint="md"
                      collapsedWidth={isMobile ? 0 : 80}
                      onBreakpoint={(broken) => {
                        setIsMobile(broken);
                        setCollapsed(broken);
                      }}
                      style={{ background: darkMode ? 'var(--dark-bg)' : 'var(--color-theme)' }}
                    >
                      <SideMenu collapsed={collapsed} onCollapseChange={setCollapsed} />
                    </Sider>
                    <Layout>
                      <Header
                        style={{
                          padding: 0,
                          background: darkMode ? 'var(--dark-bg)' : 'var(--color-bg)',
                          boxShadow: darkMode ? '0 1px 4px rgba(0,0,0,0.15)' : '0 1px 4px rgba(0,21,41,0.08)'
                        }}
                      >
                        <HeaderComponent collapsed={collapsed} toggle={toggleSider} routePaths={protectedRoutes.map((r) => r.path)} />
                      </Header>
                      <Content style={{ background: darkMode ? 'var(--dark-bg)' : 'var(--color-bg)' }}>
                        {route.element}
                      </Content>
                      {/* Son 5 dk: üstte kırmızı sayaç + uyarı (sabit konumlu, yerleşimi etkilemez) */}
                      <OturumSayaci />
                    </Layout>
                  </Layout>
                }
              />
            ))}
            <Route path="/*" element={<Navigate to="/giris" replace />} />
          </Routes>
        </Router>
      </AntdApp>
    </ConfigProvider>
  );
};

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;